import React from 'react';
import { connect } from 'react-redux'
import '../../App.css';
import { redirectTo } from '../../action/redirection';
import * as cartProductDetailsAction from '../../action/cartProductDetailsAction';
import * as productsAction from '../../action/productsAction';
import ReactHtmlParser from "react-html-parser";
import { Utils } from '../../util/utils';
import Magnifier from '../../components/magnifier';
import ProductDetailColor from './productDetailColor';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {TileletCarousel} from '@vds/tiles'
import { updateSCTags, getDTMInit } from './../../service/dtmTag';
import { getVZDLInit } from './../../service/vzdl';
import Modal from 'react-responsive-modal';
import { catchJSException, checktime } from './../../service/logService';
import { withCookies } from 'react-cookie';
import { Pages } from '../../constants/actionType'
import MarketingTile from './MarketingTile';

class ProductDetailsValue extends React.PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            optionDisplay: false,
            qtyValue: 1,
            imageIndex: 0,
            ImgNav1: null,
            ImgNav2: null,
            openFlag: false,
            activeLink: 0,
            outOfStock: false,
            quantityValue: false,
            signIn: false


        }
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.onBlurHandler =this.onBlurHandler.bind(this);
        this.onEscape = this.onEscape.bind(this);
    }
    next(imgLength) {
        if (this.state.activeLink <= imgLength - 2) {
            this.slider1.slickNext();
            this.setState({ activeLink: this.state.activeLink + 1 })
        }
        setTimeout(() => {
        if(document.getElementsByClassName("carousel_pager-item slideActive") && document.getElementsByClassName("carousel_pager-item slideActive").length === 1 ){            
            document.getElementsByClassName("carousel_pager-item slideActive")[0].focus();      
            setTimeout(() => {
                if(document.getElementById("next_btn")){
                    document.getElementById("next_btn").focus();
                }
            }, 500)
            }
        },200)
    }
    previous() {
        if (this.state.activeLink >= 1) {
            this.slider1.slickPrev();
            this.setState({ activeLink: this.state.activeLink - 1 })
        }
        setTimeout(() => {
            if(document.getElementsByClassName("carousel_pager-item slideActive") && document.getElementsByClassName("carousel_pager-item slideActive").length === 1 ){            
                document.getElementsByClassName("carousel_pager-item slideActive")[0].focus();      
                setTimeout(() => {
                    if(document.getElementById("previous_btn")){
                        document.getElementById("previous_btn").focus();
                    }
                }, 500)
                }
            },200)
    }

    addToCartLog = ((pagestate) => {
        return {
            page: 'AddToCart',
            mount: (pagestate === 'Mount') && Date.now(),
            unmount: (pagestate === 'WillMount') && Date.now(),
            pageURL: window.location.href,
            visitid: this.props.appState.visitId || 'visit_id_not_created',
            noSSNCheck: false,
            apiFetched: (pagestate === 'ApiFetched') && Date.now()
        }
    })
    addToCart = (productDetails, quantity) => {
        try {
            let Qty = "";
            let productName = productDetails.name;
            // let selectedCategoryName = this.props.categoryState.categoriesExp.find(obj => obj.categoryId === productDetails.categoryId).name
            //let scTagData = "cartadd_" + selectedCategoryName + "_".concat(productName);
            let scTagData = "add to cart: ".concat(productName);
            updateSCTags(scTagData);            
            Qty = this.prodExistInCart(productDetails, quantity);
            if (Qty !== -1) {
                this.doAddToCart(productDetails, Qty);
            }
            else {
                this.setState({
                    openFlag: true,
                    quantityValue: true,
                    outOfStock: false

                })
                document.getElementById("cart-alert-notadded").setAttribute("role", "");
                document.getElementById("cart-alert-notadded").setAttribute("role", "alert")
            }

        } catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'addToCart', ex);
        }
    }


    prodExistInCart = (productDetails, quantity) => {
        try {
            let machedObj = "";
            let Qty = quantity;
            let cartData = this.props.cartProduct && this.props.cartProduct.cartProduct;
            cartData && cartData.forEach((cartPdp)=>{
                if (productDetails.productId === cartPdp.pppId && productDetails.itemId === cartPdp.itemId) {
                    Qty+= parseInt(cartPdp.qty,10);
                    machedObj="yes";
                }
            })
            // this.props.cartProduct && this.props.cartProduct.cartProduct.find((obj) => {
            //     if (productDetails.productId === obj.pppId && productDetails.itemId === obj.itemId) {
            //         machedObj = obj;
            //     }
            //     // return "";
            // })
            if (machedObj !== "" && machedObj !== null) {
                //cart already has same product
                //Qty += parseInt(machedObj.qty, 10);
                if (Qty > parseInt(productDetails.maxQty, 10)) {
                    //should not allow to add add more qty need to show popup saying exceeds limit
                    Qty = -1
                }
            }
            return Qty;
        }
        catch (ex) {
            catchJSException('productsList', this.props.appState.visitId, 'prodExistInCart', ex);
        }
    }

    doAddToCart = (productDetails, quantity) => {
        try {
            //let productName = productDetails.name;
            //let scTagData = "add to cart: ".concat(productName);
            //updateSCTags(scTagData);
            var productInfo = {
                productId: productDetails.productId,
                itemId: productDetails.itemId,
                productType: "PPP",
                quantity: quantity,
                serviceType: "ACCESSORIES",
                status: "add",
                category: productDetails.categoryId,
                addlInfo: [{ "key": "categoryName", "value": this.props.categoryState.categoriesExp.find(obj => obj.categoryId === productDetails.categoryId).name }, { "key": "signedIn", "value": this.props.categoryState.isValidUser }],
                orderType: "",
                promoId: (productDetails.promotion && productDetails.promotion.crmmCode) ? productDetails.promotion.crmmCode : "",
                mlpFlow : (this.props.appState && this.props.appState.mlpFlow) ? this.props.appState.mlpFlow : false,
                redemptionProductName : (this.props.appState && this.props.appState.mlpPDP) ? this.props.appState.mlpPDP : "",
                accessoryType: "vtp"
            };
            let request = JSON.stringify(productInfo);
            let validatePromise = productsAction.updateCart(request, this.props.appState.visitId, this.props.dispatch);
            Promise.all([validatePromise])
                .then(                
                    showCart => {
                        cartProductDetailsAction.showCart(false, this.props.dispatch);
                        setTimeout(() => { cartProductDetailsAction.showCart(true, this.props.dispatch)}, 3000)
                         if(showCart && showCart.length && showCart[0].data && showCart[0].data.prodAccessoryList && showCart[0].data.prodAccessoryList.length){
                            document.getElementById("cart-alert").setAttribute("role", "");
                            document.getElementById("cart-alert").setAttribute("role", "alert")
                         }
                         
                        checktime(this.addToCartLog('Mount'));
                        let transactionData = {
                            visitId: this.props.appState.visitId
                        }
                        let txnData = {
                            total : this.props.cartProduct.total,
                            taxAmt : this.props.cartProduct.tax,
                            shippingZip : "",
                            shippingCharge : this.props.cartProduct.shippingcrg,
                            paymentType : "",
                            status : ""
                        }
                        getDTMInit("addToCart", "", "", true, "", this.props.cartProduct, "", productDetails.itemName, transactionData);                        
                        if (this.props.cartProduct.cartProduct && this.props.cartProduct.cartProduct.length === 1 && this.props.cartProduct.cartProduct[0].qty === "1") {
                            getVZDLInit(this.props.appState.visitId, productDetails.name, "", true, "cartadd_pdp", "scOpen,scAdd","Accessories","","",{cartData : this.props.cartProduct.cartProduct,currentlyselected : productDetails.itemName,txnData : txnData});
                          } else {
                            getVZDLInit(this.props.appState.visitId, productDetails.name, "", true, "cartadd_pdp", "scAdd","Accessories","","",{cartData : this.props.cartProduct.cartProduct,currentlyselected : productDetails.itemName,txnData : txnData});
                          }
                       if( Utils.isMobileView()){  this.OnViewcartClick()}
                       
                    }
                ).catch()
        } catch (ex) {
            catchJSException('productDetails', this.props.appState.visitId, 'addToCart', ex);
        }
    }

    onProductItemClick = () => {
        try {

            let redirectURL = "/home/accessories/begincheckout";
            redirectTo(redirectURL, this.props.props.props)
        } catch (ex) {
            catchJSException('productDetails', this.props.appState.visitId, 'onProductItemClick', ex);
        }
    }
    OnViewcartClick = (() => {
        try {
            updateSCTags("view cart");
            //getDTMInit("viewCart", "", "", true);
            let redirectURL = Pages.ShoppingCart;
            redirectTo(redirectURL, this.props.dispatch);
        } catch (ex) {
            catchJSException('cart', this.props.appState.visitId, 'OnViewcartClick', ex);
        }
    })

    displayQty = () => {        
        try {
            this.setState({
                ...this.state,
                optionDisplay: !this.state.optionDisplay
            })            
        } catch (ex) {
            catchJSException('productDetails', this.props.appState.visitId, 'displayQty', ex);
        }
    }
    updateQty = (val) => {
        try {
            this.setState({
                ...this.state,
                qtyValue: val
            }, () => {
                this.setState({
                    ...this.state,
                    optionDisplay: !this.state.optionDisplay
                })
            })            
        } catch (ex) {
            catchJSException('productDetails', this.props.appState.visitId, 'updateQty', ex);
        }
    }
    componentWillMount() {
        let categoryList = this.props.categoryState && this.props.categoryState.categoriesExp
        let productList = this.props.productState && this.props.productState.productsExp
        let featuredAcessoriesList = this.props.categoryState && this.props.categoryState.featuredAccessoriesExp
        let othersViewedList = (this.props.othersViewedState.otherValue === undefined) ? undefined : this.props.othersViewedState.otherValue
        let urlName = this.props.props ? this.props.props.match.params.pageName : this.props.match.params.pageName
        let actualExpName = undefined
        if (actualExpName === undefined && Utils.isNotNull(categoryList)) {
            actualExpName = categoryList.find(obj => obj.modifiedName === urlName)
        }
        if (actualExpName === undefined && Utils.isNotNull(featuredAcessoriesList)) {
            actualExpName = featuredAcessoriesList.find(obj => obj.modifiedName === urlName)
        }
        if (actualExpName === undefined && Utils.isNotNull(othersViewedList)) {
            actualExpName = othersViewedList.find(obj => obj.modifiedName === urlName)
        }
        if (actualExpName === undefined && Utils.isNotNull(productList)) {
            actualExpName = productList.find(obj => obj.modifiedName === urlName)
        }
        //actualExpName = actualExpName ? actualExpName.name : ''
        actualExpName = actualExpName ? actualExpName.name : urlName.replace(/[-]/g, " ")
        // let productName = this.props.products.productsExp.find((value) => value.modifiedName === this.props.props.match.params.pageName).name;  
        let transactionData = {
            visitId: this.props.appState.visitId
        }
        let txnData = {
            total : this.props.cartProduct.total,
            taxAmt : this.props.cartProduct.tax,
            shippingZip : "",
            shippingCharge : this.props.cartProduct.shippingcrg,
            paymentType : "",
            status : ""
        }
        setTimeout(() => {
            let category = [];
            let prodId = [];
            let otherValue = [];
            if (this.props.othersViewedState.otherValue && this.props.categoryState.categoriesExp) {
                for (var i = 0; i < this.props.othersViewedState.otherValue.length; i++) {
                    category[i] = (this.props.categoryState.categoriesExp.find(obj => obj.categoryId === this.props.othersViewedState.otherValue[i].selectedOtherProd.categoryId).name);
                    prodId[i] = (this.props.othersViewedState.otherValue[i].productId);
                }
                if((category && category.length !== 0) && (prodId && prodId.length !== 0)){
                    for (var i = 0; i < category.length; i++) {
                        for (var j = 0; j < prodId.length; j++) {
                            otherValue[i,j] = { "category": category[i], "productId": prodId[j] };
                        }
                    }
                }             
            }
            getDTMInit("accessoriesPdpCategories", this.props.selectedCategory, actualExpName, "", "", "", "", "", transactionData);
            getVZDLInit(this.props.appState.visitId,actualExpName, this.props.selectedCategory,"","","prodView","Accessories","","",{cartData : this.props.cartProduct.cartProduct,txnData : txnData},"",otherValue);          
            }, 100);
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    handleClickOutside(event) {
        try {
            if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
                this.setState({

                    optionDisplay: false
                })
            }
        } catch (ex) {
            catchJSException('productDetails', this.props.appState.visitId, 'handleClickOutside', ex);
        }
    }
    onCloseModal = () => {
        try {
            this.setState({ openFlag: false, outOfStock: false, quantityValue: false });
        } catch (ex) {
            catchJSException('productDetails', this.props.appState.visitId, 'onCloseModal', ex);
        }
    }
    outOfStock = (selectedItem) => {
        try {
            this.setState({
                openFlag: true,
                outOfStock: true,
                quantityValue: false
            })
        } catch (ex) {
            catchJSException('productDetails', this.props.appState.visitId, 'outOfStock', ex);
        }
    }
    handleActiveSlide = (id) => {
        this.setState({ activeLink: id });        
    };



    componentDidMount() {
        this.setState({
            ImgNav1: this.slider1,
            ImgNav2: this.slider2
        });
    }
    onCombochange(e,btnId,val){
        let maxQty = (this.props.productDetailsValue.maxQty !== undefined || this.props.productDetailsValue.maxQty !== "") ? this.props.productDetailsValue.maxQty : 0;
        if(btnId === "qty_dropdown_btn" && e.keyCode === 40){
            if(val < maxQty){
                e.preventDefault();
                this.setState({
                    ...this.state,
                    qtyValue: val + 1
                });
                document.getElementById(btnId).focus();
                document.getElementById(btnId).setAttribute("aria-label","selected quantity" + (this.state.qtyValue + 1));
            }            
        } else if(btnId === "qty_dropdown_btn" && e.keyCode === 38){
            if(val !== 1){
                e.preventDefault();
                this.setState({
                    ...this.state,
                    qtyValue: val - 1
                });
                document.getElementById(btnId).focus();
                document.getElementById(btnId).setAttribute("aria-label","selected quantity" + (this.state.qtyValue - 1));
            }            
        }
    }
    onComboListDown(e,btnId){
        if (e.keyCode === 40 || e.keyCode ===39) {
            if(document.getElementById(btnId) &&  document.getElementById(btnId).nextElementSibling){
                    document.getElementById(btnId).nextElementSibling.focus();   
            }
    
        }
        else if (e.keyCode === 37|| e.keyCode === 38) {
                if(document.getElementById(btnId) &&  document.getElementById(btnId).previousElementSibling){
                    document.getElementById(btnId).previousElementSibling.focus();
                   
                }
        }        
    }
    onComboListEnter(e,i){
        if(i){
            this.updateQty(i);
            document.getElementById('qty_dropdown_btn').focus();        
        }       

    }
    /**on dropdown focus out or escape key press */
    onBlurHandler(e) {
       
        if(!e.currentTarget.contains(e.relatedTarget)){
            if (this.state.optionDisplay) {
              setTimeout(() => {
                  this.setState({
                      optionDisplay: false
                  });
                });
            
          }
        }
        }
  
        onEscape(e){
            if(e.keyCode === 27){
              this.onBlurHandler(e);
            }
  
        }
  
    render() {
        const { openFlag } = this.state;
        var navImgSettings1 = {
            speed: 500,
            slidesToScroll: 1,
            arrows: false,
            className: "productdetails",
            asNavFor: this.state.ImgNav1,
            ref: slider => (this.slider2 = slider),
            infinite: true,
            focusOnSelect: true

        };
        var navImgSettings2 = {
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            className: "productdetails",
            asNavFor: this.state.ImgNav1,
            ref: slider => (this.slider2 = slider),
            infinite: false,
            focusOnSelect: true
        };
        let screenWidth = window.screen ? window.screen.width : 0;
        var ImgSettings = {
            arrows: false,
            speed: 500,
            // fade: true,
            className: "productdetailsImgs",
            asNavFor: this.state.ImgNav2,
            ref: slider => (this.slider1 = slider),
            infinite: false,
            focusOnSelect: false

        };

        let carouselImagesList = [];
        let productImagesList
        let displayPrice = '';
        let seletedDetails = [];
        let displayName = '';
        let domain = Utils.getDomainUrl();
        let maxQnty = '';
        let carouselImage;
        let qtyValue = [];
        let qtyList = [];
        let specs = [];
        let items = [];
        let images = [];
        let navSlider
        let promotionDuration = ''
        let priceOff = ''
        let actualPrice = ''
        let promotionAvailable = false;
        let viewPriceInCart = false;
        let dropDownContent = ''
        let limitedInventory= false;
        let saleImage = '';
        // const imageClick = (index) => {
        //     this.setState({ ...this.state.imageIndex, imageIndex: index })
        // }

        if (this.props.productDetailsValue) {
            images = this.props.productDetailsValue.images
            maxQnty = this.props.productDetailsValue.maxQty
            displayPrice = this.props.productDetailsValue.price
            seletedDetails = this.props.productDetailsValue
            displayName = this.props.productDetailsValue.itemName
            specs = this.props.productDetailsValue.specification
            items = this.props.item
            actualPrice = this.props.productDetailsValue.actualPrice
            const setHeadingLevel=document.getElementsByClassName('products-description_title');
            for(let i=0; i<setHeadingLevel.length; i++){
                setHeadingLevel[i]?.setAttribute('role','heading');
                setHeadingLevel[i]?.setAttribute('aria-level','2');
            }
            if (this.props.productDetailsValue.promotion) {
                promotionAvailable = true
                promotionDuration = this.props.productDetailsValue.promotion.duration
                priceOff = this.props.productDetailsValue.promotion.priceOff
                viewPriceInCart = this.props.productDetailsValue.promotion.viewPriceInCart
                saleImage = this.props.productDetailsValue.promotion.saleImage ? this.props.productDetailsValue.promotion.saleImage : "";


            }
            if(this.props.productDetailsValue.limitedInventory)
            {
                limitedInventory=this.props.productDetailsValue.limitedInventory
            }
           //Adding null check - Page will render even if images are null from backend
           if(images) { 
            carouselImage = images.map((images, index) => {
                return (
                    <div key={index}>
                        {/* <span role="button" tabIndex="0" className={"carousel_pager-item " + (index === this.state.activeLink ? "slideActive" : "slideDeActive")} onClick={() => this.handleActiveSlide(index)}  style={{ background: `url(${domain + images.imagePath})  0% 0% / 40px 40px no-repeat` }} title={images.altText}></span>                         */}
                        {/* <span role="button" tabIndex="0" aria-pressed={(index === this.state.activeLink ? "slideActive" : "slideDeActive")==="slideActive"? "true":"false"} className={"carousel_pager-item " + (index === this.state.activeLink ? "slideActive" : "slideDeActive")} onClick={() => this.handleActiveSlide(index)} onKeyPress={()=>this.handleActiveSlide(index)} style={{ background: `url(${domain + images.imagePath})  0% 0% / 40px 40px no-repeat` }} title={images.altText}></span> */}
                        <span role="button" tabIndex={(index === this.state.activeLink ? "slideActive" : "slideDeActive") === "slideActive"? "0":"-1"} aria-pressed={(index === this.state.activeLink ? "slideActive" : "slideDeActive")==="slideActive"? "true":"false"} className={"carousel_pager-item " + (index === this.state.activeLink ? "slideActive" : "slideDeActive")} onClick={() => this.handleActiveSlide(index)} onKeyPress={()=>this.handleActiveSlide(index)} style={{ background: `url(${Utils.getImagePath(images.imagePath)})  0% 0% / 40px 40px no-repeat` }} title={images.altText}></span>
                    </div>
                )
            })
            productImagesList = images.map((images, index) => {
                return (
                    <ul style={{ width: "", display: "inline-block" }} className="carousel_list">
                        {/* <li style={{ width: "700px" }} className="carousel_item " key={index}> */}
                        <li className="carousel_item " key={index}>
                            <div className="row">
                                <div className="columns text-center">
                                    <Magnifier src={Utils.getImagePath(images.imagePath)} alt={images.altText} />
                                </div>
                            </div>
                        </li>
                    </ul>
                )
            })
            carouselImagesList = [];
            images.map((images, index)=> {
                carouselImagesList.push(
                    {
                        key: index,
                        backgroundImage: `${Utils.getImagePath(images.imagePath)}`,
                        showBorder: true,
                        onClick: () => {},
                        ariaLabel: `${images.altText}`
                    },
                )
            })
            for (let i = 1; i <= maxQnty; i++) {
                qtyValue.push(i);
            }
            for (let i = 1; i <= maxQnty; i++) {
                qtyList.push(
                    <li tabindex={`${this.state.qtyValue === i ? '0' : '1'}`} onKeyPress={(e)=>this.onComboListEnter(e,i)} onClick={() => this.updateQty(i)} id= {'qtyCombo_'+ i} onKeyDown={(e) => { this.onComboListDown(e,'qtyCombo_'+ i)}} className={`${this.state.qtyValue === i ? 'active' : ''}`}>{i}</li>
                )
            }
            if (images.length === 1 || images.length < 4) {
                navSlider = (
                    <Slider {...navImgSettings1} slidesToShow={images.length}>
                        {carouselImage}
                    </Slider>
                )
            }
            else {
                navSlider = (
                    <Slider {...navImgSettings2}>
                        {carouselImage}
                    </Slider>
                )
            }
        }
            let url = window.location.href.toLowerCase();

            if (url.indexOf('/accessories') !== -1) {
                if (/android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())) {
                    //Mobile
                    dropDownContent = (
                        <ul className="select-box_options" data-dropdown-options="" data-quantity="product" style={{ width: '135px', display: this.state.optionDisplay ? 'block' : 'none' }}>
                            {qtyList}
                        </ul>
                    )
                } else if (/Tablet|iPad/i.test(navigator.userAgent.toLowerCase())) {
                    //Tablet
                    dropDownContent = (
                        <ul className="select-box_options" data-dropdown-options="" data-quantity="product" style={{ width: '146px', display: this.state.optionDisplay ? 'block' : 'none' }}>
                            {qtyList}
                        </ul>
                    )
                } else {
                    //Desktop
                    dropDownContent = (
                        <ul className="select-box_options" data-dropdown-options="" data-quantity="product" style={{ width: '145px', display: this.state.optionDisplay ? 'block' : 'none' }}>
                            {qtyList}
                        </ul>
                    )
                }
            }
        }
        return (
            <React.Fragment>
                <div className="" data-page-content="1" >
                    <Modal open={openFlag} center focusTrapped={true} showCloseIcon={false} onOverlayClick={()=> this.onCloseModal()} onEscKeyDown={()=> this.onCloseModal()}>
                    <a onClick={() => this.onCloseModal()} onKeyPress={() => this.onCloseModal()} class="vzicon close-faq" tabIndex="0" aria-label="Close" role="button">&times;</a>
                        <div >
                            <div >
                                {this.state.outOfStock === true &&
                                <div className="modal_header">
                                    <h4 class="tiny-padding-right-large medium-padding-right-zero">Item is out of stock</h4>
                                </div>}
                            </div>

                            <div >
                                {this.state.quantityValue === true &&
                                    <div className="modal_header">
                                        <h4 tabIndex="-1" className="margin-bottom-zero" role="heading" aria-level="2">Sorry!</h4>
                                    </div>}
                                {this.state.quantityValue === true &&

                                    <div className="modal_content" style={{ maxHeight: "534.5px", height: "207px"  }}>
                                        <p className="products-description_details">
                                            There are limits on the quantity of each product you can add to your cart. You have reached that limit for this product.</p>
                                        <p className="products-description_details">
                                            Please continue shopping or check out with the items already in your cart.<br></br>
                                            &nbsp; </p>
                                        <p>
                                            &nbsp;</p></div>}
                            </div>

                            <div className="modal_footer">
                                <div class="support_ok right margin-bottom-medium">
                                    <button lid="ok" onClick={() => this.onCloseModal()} className="button no-focus-effect" tabindex="0" aria-label="Close">Ok </button>
                                </div>
                            </div>
                        </div>
                    </Modal>
                </div>
                <div id="skuImages">
                    <h3 class="products-list_title">{displayName}</h3>
                    {
                        screenWidth > 500 ? (
                            <div className="w_products-list">
                        <div className="products-list_carousel">
                            <div className={priceOff ? viewPriceInCart ? "hide" : "products-list_offer" : "hide"}>
                                <div className="products-list_offer-value">{priceOff.toUpperCase()}</div>
                                {/* <div className="products-list_offer-off">Off</div>  */}
                            </div>
                            <div className="w_carousel" aria-hidden='true' style={{ height: "368px", overflow: "visible" }}>
                                {/* <ul style={{ width: "", display: "inline-block" }} className="carousel_list"> */}
                                    <Slider {...ImgSettings}>
                                        {productImagesList}
                                    </Slider>
                                {/* </ul> */}
                                <div id="portal" className="portal" style={{ left: "470px" }} />
                            </div>
                            {images && images.length>1&&<div className="thumbnail-pagination">
                                <div className="seperate_prev" >
                                    {/* <div id="previous_btn" className={"carousel_pager-prev " + (this.state.activeLink <= 0 ? "disable" : "")} style={{ float: "right" }} tabIndex={this.state.activeLink <= 0 ? "-1" : "0"} aria-label="previous" onClick={this.previous} onKeyPress={this.previous} role="button"></div> */}
                                    <div id="previous_btn" className={"carousel_pager-prev " + (this.state.activeLink <= 0 ? "disable" : "")} style={{ float: "right" }} tabIndex={this.state.activeLink <= 0 ? "-1" : "0"} aria-label="previous" onClick={this.previous} onKeyPress={this.previous} aria-disabled={this.state.activeLink <= 0 ? true : false} role="button"></div>
                                </div>
                                  <div className="carousel_pager" >
                                    <div className="carousel_pager-list scroll" >
                                        {navSlider}
                                    </div>
                                </div>
                                <div className=" seperate_next">
                                    {/* <div id="next_btn" className={"carousel_pager-next " + (this.state.activeLink >= images.length - 1 ? "disable" : "")} style={{ float: "left" }} tabIndex={this.state.activeLink >= images.length - 1 ? "-1" : "0"} aria-label="next" onClick={() => { this.next(images.length) }} onKeyPress={() => { this.next(images.length) }} role="button"></div> */}
                                    <div id="next_btn" className={"carousel_pager-next " + (this.state.activeLink >= images.length - 1 ? "disable" : "")} style={{ float: "left" }} tabIndex={this.state.activeLink >= images.length - 1 ? "-1" : "0"} aria-label="next" onClick={() => { this.next(images.length) }} onKeyPress={() => { this.next(images.length) }} 
                                    aria-disabled={this.state.activeLink >= images.length - 1 ? true : false} role="button"></div>
                                </div>
                            </div>}
                        </div>
                    </div>
                        ) : (
                            <TileletCarousel 
                                layout='1UP'
                                gutter='20px'
                                peek='standard'
                                surface='light'
                                paginationFill='light'
                                paginationInset='12px'
                                paginationDisplay='persistent'
                                aspectRatio='1:1'
                                data={carouselImagesList}
                            />
                        )
                    }
                    

                    <div className="w_products-details">
                        <h1 className="products-details_heading margin-top-zero padding-top-zero margin-bottom-tiny">{displayName}</h1>
                        <div className="products-details_list">
                            {ReactHtmlParser(specs)}
                        </div>
                        <div className="products-details_cart">
                            <div className="products-details_price">
                                <div className="product-details_sale">
                                    <div className="product_promo-section">
                                        <div className={priceOff ? viewPriceInCart ? "hide" : '' : "hide"}>
                                            <span className= {saleImage ? "" : "vzicon icon-price-tag medium"} aria-hidden="true">
                                                {saleImage ? <React.Fragment> <img src={Utils.getImagePath(saleImage)}></img>&nbsp;</React.Fragment> : ""}
                                                </span><span className="sr-only">Tag</span>
                                            <span className="uppercase product_promo-text text-brand-1 bold">  SALE {priceOff}</span> <br />{promotionDuration}                                      </div>
                                    </div>
                                    <div className="products-details_color-section">
                                        <div className="products-details_color left margin-right-small ">
                                            <ProductDetailColor colorSelectionValue={this.props.colorSelection} itemValue={items} selectedValue={seletedDetails} />
                                        </div>
                                        <div onKeyDown={this.onEscape} onBlur={this.onBlurHandler} className="w_select-box" ref={this.setWrapperRef} >
                                        <button tabindex = "0" id="qty_dropdown_btn" role="combobox" aria-expanded = {this.state.optionDisplay} aria-label="Update Quantity" className="select-box_selected" onClick={this.displayQty} onKeyDown={(e)=> {if(e.keyCode === 13){ this.displayQty}else if(e.keyCode === 38 || 40){this.onCombochange(e,"qty_dropdown_btn",this.state.qtyValue)}}} data-dropdown=""> <span> ({this.state.qtyValue}) </span> </button> 
                                            {/* <button tabindex = "0" role="combobox" aria-expanded = {this.state.optionDisplay} aria-label="Update Quantity" className="select-box_selected" onClick={this.displayQty} onKeyDown={(e) => { this.onComboListDown(e,'qtyCombo_'+ this.state.qtyValue)}} data-dropdown=""> <span> ({this.state.qtyValue}) </span> </button>  */}
                                            {/* <div tabindex = "0" id="qty_dropdown_btn" role="combobox" aria-expanded = "false" aria-label="Update Quantity" className="select-box_selected" onClick={this.displayQty} onKeyPress={(e)=>this.displayQty(e,this.state.qtyValue)}  data-dropdown=""> <span> ({this.state.qtyValue}) </span> </div> */}
                                            {dropDownContent}
                                        </div>
                                    </div>
                                    <div className="bold product-details_limited">
                                    <div className={limitedInventory ? "":"hide"}>
                                            We have limited inventory
                                    </div>
                                    </div>
                                    <div className="">
                                        <div className={promotionAvailable ? "" : "hide"}>
                                            <span className="bold clear block text-large">was <span className="text-brand-31 product-details_actual-price">$ {actualPrice}</span></span>
                                            {viewPriceInCart ? <div class="tpgrid_product-view">View Sale Price in Cart</div> : <div className="bold product-details_discount-price">$ {displayPrice} /each</div>}
                                        </div>
                                        <div className={promotionAvailable ? "hide" : "bold product-details_discount-price"}>$ {displayPrice} /each</div>
                                        {/* <div className="bold product-details_discount-price"> $ {displayPrice} /each</div> */}
                                       
                                        {this.props.categoryState.nonVvcAccount ? (
                                            <div  className='apply-vvc-content-alignment' style={{ marginTop: '10px' }}>
                                           <MarketingTile />
                                                 </div>
                                          ) : null}
                                        {seletedDetails.outOfStock === true ?
                                            <button className="button" onClick={() => this.outOfStock(seletedDetails)}>Out of stock</button> :
                                            <button lid="add to cart:Beats Studio3 Wireless Over-Ear Headphone - Matte Black" onClick={() => this.addToCart(seletedDetails, this.state.qtyValue)} className="button products-details_addcart medium-p-50 left no-focus-effect" >
                                                Add to cart
                                    </button>}
                                    <p id="cart-alert"  aria-live="assertive" aria-label="Item has been added to the cart" className="sr-only" aria-hidden='true'></p>
                                    <p id="cart-alert-notadded"  aria-live="assertive" aria-label="Item has not been added to the cart" className="sr-only" aria-hidden='true'></p>
                                    </div>
                                </div></div></div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        appState: state.appVTP,
        cartProduct: state.cartProductDataVTP,
        selectedProdData: state.prodDetailsExp,
        selectedCategory: state.productsVTP.pageinfo.categoryName,
        productState: state.productsVTP,
        othersViewedState: state.prodDetailsVTP,
        categoryState: state.categoriesVTP
    }
}
export default withCookies(connect(mapStateToProps)(ProductDetailsValue));
